module.exports = __webpack_public_path__ + "static/media/stripe.cb2350be.svg";